import Divider from "../../components/common/aesthetics/Divider.jsx";
import AppBreadcrumbs from "../../components/common/breadcrumbs/AppBreadcrumbs.jsx";
import FormCreateProduct from "../../components/common/form/FormProductCreate.jsx";
import Page from "../../components/layout/Page.jsx";

const ProductCreate = () => {
  const bcSteps = [
    { to: "/products", label: "Productos" },
  ];

  return (
    <Page>
      <AppBreadcrumbs steps={bcSteps} currentPage="Crear" />

      <div>
        <h1 className="font-bold text-2xl">Crear Producto</h1>
        <span>Inserte la información del producto que quiera crear</span>
      </div>
      <Divider className="mb-10" />
      <FormCreateProduct />
    </Page>
  );
};

export default ProductCreate;
